module.exports = __webpack_public_path__ + "static/media/Soma.de65dc63.jpg";